import { Link } from "../../../../components/link";
import { route } from "../../../../shim/jsbridge";
import { AlertDescriptionVariantProps } from "../../@types";
import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";

const AlertDescriptionYaraMatch = ({
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionVariantProps) => {
  return (
    <>
      New {data.yara_scope} YARA match{" "}
      <AlertDescriptionSampleLink
        data={data}
        linksReloadDocument={linksReloadDocument}
        onLinkClick={onLinkClick}
      />{" "}
      on rule{" "}
      <Link
        variant="action"
        baseDecoration="underline"
        to={`${route(
          "yara_analytics",
          {},
          {
            name: data.yara_ruleset,
            owner: "All Rulesets"
          }
        )}`}
        onClick={onLinkClick}
        reloadDocument={linksReloadDocument}
      >
        {data.yara_rule}
      </Link>
      .
    </>
  );
};

export default AlertDescriptionYaraMatch;
